// src/pages/TermsPage.tsx
import React from 'react';
import LegalDocumentPage from './legal/LegalDocumentPage';

const TermsPage: React.FC = () => (
  <LegalDocumentPage slug="terms-of-service" fallbackTitle="Terms of Service" />
);

export default TermsPage;
